export const WORK_CENTERS = {
  navLink: 'admin-nav-work-centers',
  newButton: 'work-centers-new-button',
  dialog: 'work-centers-dialog',
  nameInput: 'work-centers-name-input',
  useMyLocationButton: 'work-centers-use-my-location-button',
  mapPicker: 'work-centers-map-picker',
  latitudeInput: 'work-centers-latitude-input',
  longitudeInput: 'work-centers-longitude-input',
  radiusInput: 'work-centers-radius-input',
  saveButton: 'work-centers-save-button',
  row: 'work-centers-row',
  editButton: 'work-centers-edit-button',
  deleteButton: 'work-centers-delete-button',
};
